export enum Theme {
	light,
	dark,
}
